import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'commerce-connect',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const component = require('./CommerceConnect').default
      callback(null, component)
    }, 'CommerceConnect')
  }
})



// WEBPACK FOOTER //
// ./src/routes/rule-ui-routes/CommerceConnect/index.js